





































import Vue from 'vue';
import {
  mapActions,
  mapGetters,
} from 'vuex';

import api from '../../api';
import ShowHeader from '../../components/ui/show/header.vue';
import ShowDetails from '../../components/ui/show/details.vue';
import UserReview from '../../components/ui/show/user-review.vue';
import ShowReviewCards from '../../components/ui/show-review-cards/show-review-cards.vue';
import CategoryCards from '../../components/ui/category-cards/category-cards.vue';
import {
  IShow,
  IShowReviewObject,
  IUserCategoryObject,
} from '../../../../shared/types';

export default Vue.extend({
  name: 'Show',

  components: {
    ShowHeader,
    ShowDetails,
    ShowReviewCards,
    UserReview,
    CategoryCards,
  },

  data: () => ({
    id: -1 as number | undefined,
    show: null as IShow | null,
    reviews: [] as IShowReviewObject[],
    averageRating: -1,
    categories: [] as IUserCategoryObject[],
  }),

  async created() {
    const {
      id,
    } = this.$route.params;

    this.id = parseInt(id, 10);
    this.handlePageLoad({
      name: this.$route.name,
    });
    this.requiresLogin();

    this.show = await api.show.get(this.id);
    this.refreshReviews();
    this.categories = await api.category.getUserCategories(this.getUser.id);
  },

  methods: {
    ...mapActions('navigation', [
      'handlePageLoad',
      'requiresLogin',
    ]),

    async refreshReviews() {
      const {
        id,
      } = this.$route.params;

      const response = await api.review.getShowReviews(parseInt(id, 10));

      if (response !== null) {
        this.averageRating = response.averageRating || -1;
        this.reviews = response.reviews || [];
      }
    },

    async handleAdd(id: number) {
      let showId = -1;
      if (this.show && 'id' in this.show) {
        showId = this.show.id || -1;
      }
      await api.category.addShow(id, showId);
      this.categories = await api.category.getUserCategories(this.getUser.id);
    },
  },

  computed: {
    ...mapGetters('user', [
      'getUser',
    ]),
  },
});
